<template>
	<form>
		<GuestHeading>Registro</GuestHeading>
		<GuestMessage style="color:red;">Es necesario registrarse antes de la compra para poder enviarte tus datos de acceso.</GuestMessage>
		<GuestErrors :class="Object.keys(errors).length>0  ? 'd-block':'d-none' ">
			<span class="d-block" v-for="error in errors" :key="error">{{error[0]}}</span>
		</GuestErrors>
		<div class="row">
			<div class="col-12 col-md-6">
				<GuestInput
					placeholder="Nombre"
					name="first_name"
					v-model="first_name"
					:class="errors.first_name ? 'is-invalid':''"
				/>
			</div>
			<div class="col-12 col-md-6">
				<GuestInput
					placeholder="Apellido"
					name="last_name"
					v-model="last_name"
					:class="errors.last_name ? 'is-invalid':''"

				/>
			</div>
			<div class="col-12 col-md-6">
				<GuestInput
					type="email"
					placeholder="Email"
					name="email"
					v-model="email"
					:class="errors.email ? 'is-invalid':''"

				/>
			</div>
			<div class="col-12 col-md-6">
				<GuestInput
					type="email"
					placeholder="Repetir e-mail"
					name="email_confirmation"
					v-model="email_confirmation"
					:class="errors.email_confirmation ? 'is-invalid':''"
				/>
			</div>
			<div class="col-12 col-md-6" style="position: relative">
				<GuestPassword v-model="password" :placeholder="`Contraseña`" :class="errors.password ? 'is-invalid':''"/>
			</div>
			<div class="col-12 col-md-6">
				<GuestPassword v-model="password_confirmation" :placeholder="`Repetir contraseña`" :class="errors.password_confirmation ? 'is-invalid':''"/>
			</div>
			<div class="col-12 col-md-12">
				<GuestSelect name="source" v-model="source">
					<option disabled value="" selected>¿Cómo nos conoces?</option>
					<option value="facebook">Facebook</option>
					<option value="instagram">Instagram</option>
					<option value="linkedin">LinkedIn</option>
					<option value="google">Google</option>
					<option value="college">Escuela/instituto</option>
					<option value="friend">Familia/amigos</option>
					<option value="prensa">Prensa</option>
					<option value="other">Otros</option>
				</GuestSelect>
			</div>
			<div class="col-12">
				<p class="tnc">
					<GuestCheckBox
						name="tnc"
						id="isTnc"
						class="w-auto mr-2"
						v-model="tnc"
					/>
					<label for="isTnc"
						>Estoy de acuerdo con las condiciones de
						servicio.</label
					>
					<Link to="/terms-and-conditions">Condiciones de servicio.</Link>
				</p>
			</div>
			<div class="col-12">
				<GuestButton @click.prevent="handleFormSubmit"
					>Enviar</GuestButton
				>
			</div>
			<div class="col-12">
				<GuestMessage>
					¿Ya tienes una cuenta?
					<Link to="/login">Iniciar sesión</Link>
				</GuestMessage>
			</div>
		</div>
	</form>
</template>

<script>
import GuestPassword from '../../components/GuestPassword.vue'
import GuestCheckBox from "../../components/GuestCheckBox.vue";
import GuestButton from "../../components/GuestButton.vue";
import Link from "../../components/Link.vue";
import GuestMessage from "../../components/GuestMessage.vue";
import GuestSelect from "../../components/GuestSelect.vue";
import EyeButton from "../../components/EyeButton.vue";
import GuestInput from "../../components/GuestInput.vue";
import GuestHeading from "../../components/GuestHeading.vue";
import GuestErrors from "../../components/GuestErrors.vue";

import { ref } from "vue";
import { useStore } from 'vuex';

import User from "@/api/User";
import { useRouter } from 'vue-router';
export default {
	components: {
		GuestErrors,
		GuestHeading,
		GuestInput,
		EyeButton,
		GuestSelect,
		GuestMessage,
		Link,
		GuestButton,
		GuestCheckBox, GuestPassword
	},
	name: "RegisterPage",

	setup() {
		const store = useStore();

		const errors = ref({});
		const first_name = ref("");
		const last_name = ref("");
		const email = ref("");
		const email_confirmation = ref("");
		const password = ref("");
		const password_confirmation = ref("");
		const source = ref("facebook");
		const tnc = ref(true);
		const router = useRouter()

		const handleFormSubmit = () => {
			User.register({
				first_name: first_name.value,
				last_name: last_name.value,
				email: email.value,
				email_confirmation: email_confirmation.value,
				password: password.value,
				password_confirmation: password_confirmation.value,
				source: source.value,
				tnc: tnc.value,
			})
			.then((response)=>{
				if(response.status == 200){
					errors.value = {};
					console.log(typeof(store.dispatch('new_user',response.data.user)));
					router.push({name: 'RegisterSuccess'})
				}
			})
			.catch(errs=>{
				// validation error
				if(errs.response.status == 422){
					errors.value = errs.response.data.errors;
				}
			})
		};

		return {
			first_name,
			last_name,
			email,
			email_confirmation,
			password,
			password_confirmation,
			source,
			tnc,

			errors,
			handleFormSubmit,
		};
	},
};
</script>

<style scoped>
form {
	position: relative;
	z-index: 1;
	background: #ffffff;
	padding: 45px;
	text-align: center;
	box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
	width: 600px;
	margin: auto;
}
.tnc {
	text-align: left;
	margin-bottom: 10px;
	color: #b3b3b3;
	font-size: 12px;
}
</style>
